document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".clipboard").forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      const textToCopy = element.getAttribute("alt");

      navigator.clipboard.writeText(textToCopy).then(() => {
        const paragraph = element.querySelector("p");
        if (paragraph) {
          paragraph.textContent = "Skopiowano";
        }
      });
    });
  });
});
